import React, { FC, useMemo } from 'react';
import { IOuter } from './LoadingSection.types';
import styles from './LoadingSection.scss';
import { sum } from 'ramda';
import { Text } from '../../../components/common';
import { mapIndexed } from '../../../utils/array';

const MAX_ITEM_WIDTH = 323;
const MIN_ITEM_WIDTH = 175;
const MAX_WRAPPER_WIDTH = 1216;

const generateItemWidth = (): number => {
  return Math.floor(Math.random() * (MAX_ITEM_WIDTH - MIN_ITEM_WIDTH)) + MIN_ITEM_WIDTH;
};

const getItemsWidth = (): number[] => {
  const itemsWidth = [];
  while (sum(itemsWidth) < MAX_WRAPPER_WIDTH) {
    itemsWidth.push(generateItemWidth());
  }

  return itemsWidth;
};

export const LoadingSection: FC<IOuter> = ({ headerText, dataHook = 'recommended-loading-section' }) => {
  const itemsWidth = useMemo(() => getItemsWidth(), [headerText]);

  return (
    <div className={styles.loadingSectionHolder} data-hook={dataHook}>
      <div className={styles.header}>
        <Text weight="bold" size="medium">
          {headerText}
        </Text>
      </div>

      <div className={styles.placeHoldersWrapper}>
        {mapIndexed(
          (itemWidth: number, index) => (
            <div key={index} className={styles.placeHolder} style={{ width: itemWidth }} />
          ),
          itemsWidth,
        )}
      </div>
    </div>
  );
};
